import kea = require('node_modules/kea-react/dist/index');
import models = require("app/models/requireme");
import { rpcController } from "../rpc";
import { cacheResource } from "kea-resource";
const controller = rpcController("CargasDescargasEAD");

export const CargaDescargaEAD = cacheResource({
    /**Inica el proceso de carga/descarga de un camion de EAD. Devuelve el Id de la nueva carga/descarga */
    IniciarCargaDescarga: async (model: models.InicioCargaDescargaEADModel): Promise<number> => await controller('IniciarCargaDescarga', {}, model),

    /**Cancela una carga/descarga. Solo se puede cancelar si esta en proceso y si no tiene ningun servicio incluido */
    CancelarCargaDescarga: async (idCargaDescargaEAD: number): Promise<void> => await controller('CancelarCargaDescarga', { idCargaDescargaEAD }),

    /**Finalizar un proceso de carga/descarga */
    FinalizarCargaDescarga: async (idCargaDescargaEAD: number): Promise<void> => await controller('FinalizarCargaDescarga', { idCargaDescargaEAD }),

    /**
     * Escanea un folio ya sea para cargarlo o descargarlo, realizando las debidas validaciones.
     * Este metodo llama al SaveChanges
     */
    EscanearFolio: async (folioFisico: string, idCargaDescarga: number): Promise<models.LecturaFolioFisico> => await controller('EscanearFolio', { folioFisico, idCargaDescarga }),

    /**Quita de la carga/descarga un paquete incompleto */
    QuitarPaqueteIncompleto: async (idCargaDescargaEAD: number, idPaquete: number, numeroFisico: number): Promise<void> => await controller('QuitarPaqueteIncompleto', { idCargaDescargaEAD, idPaquete, numeroFisico }),

    /**Quita de la carga/descarga un sobre incompleto */
    QuitarSobreIncompleto: async (idCargaDescargaEAD: number, idSobre: number, numeroFisico: number): Promise<void> => await controller('QuitarSobreIncompleto', { idCargaDescargaEAD, idSobre, numeroFisico }),

    /**Quita de la carga/descarga una guia */
    QuitarGuia: async (idCargaDescarga: number, idGuia: number): Promise<void> => await controller('QuitarGuia', { idCargaDescarga, idGuia }),

    /**Consulta el listado de cargas/descargas de EAD */
    Consultar: async (filtro: models.FiltroCargaDescargaEAD): Promise<models.CargaDescargaEADDto[]> => await controller('Consultar', {}, filtro),

    /**Obtiene una carga/descarga */
    Get: async (id: number): Promise<models.CargaDescargaEADDto> => await controller('Get', { id }),

    /**Obtiene el resumen de una carga/descarga */
    ObtenerResumen: async (idCargaDescarga: number): Promise<models.ResumenCargaDescarga> => await controller('ObtenerResumen', { idCargaDescarga }),

    /**Obtiene los paquetes y sobres pendientes de acompletar guias en una carga/descarga */
    ObtenerServiciosPendientes: async (idCargaDescarga: number): Promise<models.PendientesCargaDescarga> => await controller('ObtenerServiciosPendientes', { idCargaDescarga }),

    /**Obtiene todas las guias que estan includias en la carga */
    ObtenerGuiasEnCargaDescarga: async (idCargaDescarga: number): Promise<models.GuiaDTO[]> => await controller('ObtenerGuiasEnCargaDescarga', { idCargaDescarga }),

    /**Obtiene el reporte de manifiesto de EAD */
    ReporteCargaEAD: async (idCargaDescargaEAD: number): Promise<string> => await controller('ReporteCargaEAD', { idCargaDescargaEAD }),

    /**Devuelve una lista con las guias en un camión de EAD a cierta fecha */
    GuiasEnCamion: async (idCamionEAD: number): Promise<models.GuiaDTO[]> => await controller('GuiasEnCamion', { idCamionEAD }),
}, {
        Get: true,
        ObtenerResumen: true,
        ObtenerServiciosPendientes: true,
        ObtenerGuiasEnCargaDescarga: true
    }, {
        CancelarCargaDescarga: true,
        IniciarCargaDescarga: true,
        FinalizarCargaDescarga: true,
        EscanearFolio: true,
        QuitarGuia: true,
        QuitarPaqueteIncompleto: true,
        QuitarSobreIncompleto: true,
    });


// WEBPACK FOOTER //
// ./app/resources/items/cargadescargaead.tsx